'use client';

import React from 'react';
import { Section, SectionHead } from 'app/components/Section';
import { Container, Box, Tabs, TabList, Tab, VStack, Text, Pagination } from '@shared/ui';
import i18n from '@shared/i18n';
import { Loading } from '../Loading';
import { tabConfig } from './constants';
import { useOrderList } from './hooks/useOrderList';
import { OrderCard } from './components';

export const OrderList: React.FC = () => {
    const {
        state: { orderListData, isLoading, pager, currentPage, currentTab },
        action: { setCurrentPage, setCurrentTab },
    } = useOrderList();

    const currentTabIndex = tabConfig.findIndex((tab) => tab.query === currentTab);

    const handleTabChange = (index: number) => {
        if (index >= 0 && index < tabConfig.length) {
            setCurrentTab(tabConfig[index].query);
            setCurrentPage(1, true);
        }
    };

    return (
        <Container
            minH="calc(100vh - var(--shop-ui-custom-site-header-height))"
            bg="neutral.010"
            pt="32px"
            pb={{ sm: '7rem', lg: 'max' }}
        >
            <Box maxW="1024px" mx="auto">
                <Section usePositiveButton={false}>
                    <SectionHead title={i18n.gettext('購買訂單')} />
                    <Tabs
                        sx={{
                            '.chakra-tabs__tablist': {
                                borderColor: 'neutral.030 !important',
                                borderBottom: '1px solid',
                            },
                        }}
                        index={currentTabIndex}
                        onChange={handleTabChange}
                        w="100%"
                    >
                        <TabList overflowX="auto">
                            {tabConfig.map((tab) => (
                                <Tab
                                    whiteSpace="nowrap"
                                    padding="8px 24px !important"
                                    key={tab.query}
                                >
                                    {tab.name}
                                </Tab>
                            ))}
                        </TabList>
                    </Tabs>
                    {!isLoading && (
                        <VStack mt="s">
                            {orderListData && !!orderListData.length ? (
                                orderListData?.map((order) => (
                                    <OrderCard key={order.id} order={order} />
                                ))
                            ) : (
                                <Text mt="50px" color="neutral.090">
                                    {i18n.gettext('目前沒有相關訂單')}
                                </Text>
                            )}
                            {pager && (
                                <Pagination
                                    currentPage={currentPage}
                                    totalPages={pager.pages}
                                    onPageChange={setCurrentPage}
                                />
                            )}
                        </VStack>
                    )}
                    {isLoading && <Loading />}
                </Section>
            </Box>
        </Container>
    );
};
